import { createSlice } from '@reduxjs/toolkit';

import { fetchSearchSuggestions, fetchSecondarySearchSuggestions } from './searchSuggestions.actions';
import { defaultSearchSuggestionsSlice } from './searchSuggestions.types';

const searchSuggestionsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchSearchSuggestions.pending, (state) => {
            state.submitted = true;
            state.success = false;
        });
        builder.addCase(fetchSearchSuggestions.fulfilled, (state, { payload }) => {
            state.submitted = false;
            state.success = true;
            state.suggestions = payload;
        });
        builder.addCase(fetchSearchSuggestions.rejected, (state, { meta }) => {
            if (meta.condition) {
                return;
            }
            state.submitted = false;
            state.success = false;
            state.error = true;
        });

        builder.addCase(fetchSecondarySearchSuggestions.pending, (state) => {
            state.submitted = true;
            state.success = false;
        });
        builder.addCase(fetchSecondarySearchSuggestions.fulfilled, (state, { payload }) => {
            state.submitted = false;
            state.success = true;
            state.secondarySuggestions = payload;
        });
        builder.addCase(fetchSecondarySearchSuggestions.rejected, (state, { meta }) => {
            if (meta.condition) {
                return;
            }
            state.submitted = false;
            state.success = false;
            state.error = true;
        });
    },
    initialState: defaultSearchSuggestionsSlice,
    name: 'searchSuggestions',
    reducers: {},
});

export const searchSuggestionsReducer = searchSuggestionsSlice.reducer;
